module.exports = __webpack_public_path__ + "static/media/general-debit.89241c24.svg";